import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { hasValueObjects } from "../../utils/ManageArray";
import { addEditServiceRequest } from "../../commons/ServiceRequest";
import CreateRequisitionForm from "../../components/ReimbursementRefund/CreateRequisitionForm";
import BillOfReqHdService from "../../services/billofreqhd.service";
import BillOfReqDtService from "../../services/billofreqdt.service";

export default function EditRequisition() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const ReqDt = [
    "Bill_Of_Hd_Id",
    "Wh_Code",
    "Iss_Qty",
    "Use_Status",
    "Com_Code"
  ];

  const commonHas = (data, pass) =>
    hasValueObjects(data, pass)?.hasValue?.length > 0;
  const commonNavigate = (Bill_Of_Hd_Id) => {
    const newState = { name: "edit", Bill_Of_Hd_Id };
    navigate("/reimbursement_refund/", { state: newState });
    navigate(0);
  };

  const handleSubmit = ({ data }) => {
    let BillOfReqHd = data?.BillOfReqHd;
    let BillOfReqDt;
    let Bill_Of_Hd_Id = BillOfReqHd?.Id;
    let refreshAt = "";
    delete BillOfReqHd?.Id;
    const commonMapping = (item) => ({ ...item, Bill_Of_Hd_Id });

    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: BillOfReqHdService?.editBillOfReqHds(
        Bill_Of_Hd_Id,
        BillOfReqHd
      ),
      callback: (response) => {
        BillOfReqDt = data.BillOfReqDt?.map(commonMapping);
        refreshAt = commonHas(BillOfReqDt, ReqDt) ? "ReqDt" : "ReqHd";
        if (refreshAt === "ReqDt")
          handleSubmitBillOfReqDt(BillOfReqDt, Bill_Of_Hd_Id);
      },
      navigated: (navi) =>
        navi && refreshAt === "ReqHd" && commonNavigate(Bill_Of_Hd_Id)
    });

    const handleSubmitBillOfReqDt = (data, Bill_Of_Hd_Id) => {
      data?.forEach(({ Id, ...item }) =>
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: Id
            ? BillOfReqDtService.editBillOfReqDts(Id, item)
            : BillOfReqDtService.createBillOfReqDts({ Array: [item] }),
          navigated: (navi) => navi && commonNavigate(Bill_Of_Hd_Id)
        })
      );
    };
  };

  return <CreateRequisitionForm onSubmitCallback={handleSubmit} />;
}
